<template>
  <div class="draft-conflict text-start" data-testid="draft-conflict">
    <div class="d-flex align-items-center justify-content-between gap-2">
      <span class="fs-10">{{
        $t("forwards.deals.merge.yours", { value: mine })
      }}</span>
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary py-0"
        @click="$emit('pick', 'mine')"
      >
        {{ $t("forwards.deals.merge.keep_yours") }}
      </button>
    </div>
    <div class="d-flex align-items-center justify-content-between gap-2 mt-1">
      <span class="fs-10">{{
        $t("forwards.deals.merge.saved_now", { value: theirs })
      }}</span>
      <button
        type="button"
        class="btn btn-sm btn-outline-primary py-0"
        @click="$emit('pick', 'theirs')"
      >
        {{ $t("forwards.deals.merge.use_saved") }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * One field a 409 merge could not settle: the user's value and the one saved meanwhile, each with
 * the button that keeps it. The editor holds Save until every such field is picked.
 */
defineProps<{
  /** The user's value, already formatted. */
  mine: string;
  /** The value saved meanwhile, already formatted. */
  theirs: string;
}>();

defineEmits<{
  pick: [side: "mine" | "theirs"];
}>();
</script>

<style scoped lang="scss">
.draft-conflict {
  min-width: 12rem;
}
</style>
